export default function getFlightsForPlaceFactory(ajax, getSession) {
  return async function getFlightsForPlace({ from, to }) {
    return ajax({
      resource: `flights/paths?from_location=${from}&to_location=${to}`,
      method: 'get',
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/getFlightsForPlace.js